import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { List, ListItem, ListItemText } from "@mui/material";
import styles from "./dashboard.module.scss";

const ForwardNavLink = forwardRef((props: any, ref) => (
  <NavLink {...props} innerRef={ref as any} />
));

const Sidebar = () => {
  return (
    <div className={`${styles["sidebar-wrapper"]} col-md-3 d-none d-md-block`}>
      {/*
      <Button
        variant="contained"
        disableElevation
        color="primary"
        className="w-100 mt-2 mb-1"
        component={ForwardNavLink}
        to={"/"}
        startIcon={<KeyboardBackspace/>}
      >
        Go Back
      </Button>
      */}
      <List dense component="nav">
        <ListItem
          exact
          activeClassName={styles["selected"]}
          button
          component={ForwardNavLink}
          to={"/dashboard/purchases"}
        >
          <ListItemText primary="My Purchases" />
        </ListItem>
        <ListItem
          exact
          activeClassName={styles["selected"]}
          button
          component={ForwardNavLink}
          to={"/dashboard/security"}
        >
          <ListItemText primary="Security" />
        </ListItem>
      </List>
    </div>
  );
};
export default Sidebar;
